import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAutoResizeTextarea]'
})
export class AutoResizeTextareaDirective {
  private static readonly useNewChatbot: boolean | null = null;
  private static minHeight: number = 44;
  constructor(private readonly elementRef: ElementRef, private readonly renderer: Renderer2) {}

  public static setUseNewChatbot(value: number): void { // Ensure this is static
    this.minHeight = value;
  }

  @HostListener('input', ['$event.target'])
  onInput(): void {
    this.adjustHeight();
  }
  

  public adjustHeight(): void {
    const textArea: HTMLTextAreaElement = this.elementRef.nativeElement;
    const maxHeight = 160;
    this.renderer.setStyle(textArea, 'overflow-y', 'hidden');
    this.renderer.setStyle(textArea, 'height', `${AutoResizeTextareaDirective.minHeight}px`);
    const newHeight = textArea.scrollHeight > AutoResizeTextareaDirective.minHeight ? textArea.scrollHeight : AutoResizeTextareaDirective.minHeight;
    this.renderer.setStyle(textArea, 'height', `${newHeight}px`);
    this.renderer.setStyle(textArea, 'overflow-y', newHeight >= maxHeight ? 'auto' : 'hidden');
  }
  public resetHeight(): void {
    const textArea: HTMLTextAreaElement = this.elementRef.nativeElement;
    this.renderer.setStyle(textArea, 'overflow-y', 'hidden');
    this.renderer.setStyle(textArea, 'height', `${AutoResizeTextareaDirective.minHeight}px`);
    this.renderer.addClass(textArea, 'prompt-ready');
  }

}